module.exports = __webpack_public_path__ + "static/img/action-zx2.de3652ce.png";